export default {
	init() {
		const blocks = document.querySelectorAll('.block-gallery');

		if (!blocks.length) return;

		blocks.forEach((block) => {
            const btnWrapper = block.querySelector('.view-more-container');
			const btn = block.querySelector('.view-more-btn');
			const items = block.querySelectorAll('.image-item');

			if (!btn || !items.length) return;

			const styles = getComputedStyle(block);
			const limit = parseInt(styles.getPropertyValue('--limit')) || 6;

			let visibleCount = limit;

			items.forEach((item, index) => {
				if (index >= limit) {
					item.classList.add('is-hidden');
				}
			});

			btn.addEventListener('click', () => {
				visibleCount += limit;

				items.forEach((item, index) => {
					if (index < visibleCount) {
						item.classList.remove('is-hidden');
					}
				});

				if (visibleCount >= items.length) {
					btnWrapper.style.display = 'none';
				}
			});
		});
	},
};